<template>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <vehicle-detail
          label="VRN"
          :value="vehicle.registration"
        ></vehicle-detail>

        <vehicle-detail
          label="Vehicle Type"
          :value="vehicle.type?.label"
        ></vehicle-detail>

        <vehicle-detail
          v-if="!!vehicle.driver?.id"
          label="Driver"
          :value="vehicle.driver?.full_name"
        ></vehicle-detail>

        <vehicle-detail
          label="Vehicle Group"
          :value="vehicle.group?.name"
        ></vehicle-detail>

        <vehicle-detail
          label="Vehicle Make"
          :value="vehicle.make?.label"
        ></vehicle-detail>

        <vehicle-detail
          label="Vehicle Model"
          :value="vehicle.model"
        ></vehicle-detail>

        <vehicle-detail
          label="Vehicle Transmission"
          :value="vehicle.transmission?.label"
        ></vehicle-detail>

        <vehicle-detail
          label="Vehicle Colour"
          :value="vehicle.colour"
        ></vehicle-detail>

        <vehicle-detail
          label="Vehicle VIN"
          :value="vehicle.vin"
        ></vehicle-detail>

        <vehicle-detail label="Extras" :value="extras"></vehicle-detail>

        <vehicle-detail
          label="Comments"
          :value="vehicle.comments"
        ></vehicle-detail>
      </div>
      <div class="col-lg-6">
        <vehicle-detail
          label="Hire Site"
          :value="vehicle.hire_site?.name"
        ></vehicle-detail>

        <vehicle-detail
          label="Vehicle Status"
          :value="vehicle.status?.label"
        ></vehicle-detail>

        <vehicle-detail
          label="Registration Date"
          :value="vehicle.registered_at | date"
        ></vehicle-detail>

        <vehicle-detail
          label="Tax Expiry"
          :value="vehicle.tax_expires_at | date"
        ></vehicle-detail>

        <vehicle-detail
          label="MOT Expiry"
          :value="vehicle.mot_expires_at | date"
        ></vehicle-detail>

        <vehicle-detail
          label="Lease Start Date"
          :value="vehicle.lease_start_date | date"
        ></vehicle-detail>

        <vehicle-detail
          label="Lease End Date"
          :value="vehicle.lease_end_date | date"
        ></vehicle-detail>

        <vehicle-detail
          label="Cost Per Month"
          :value="vehicle.cost_per_month | currency"
        ></vehicle-detail>

        <vehicle-detail
          label="P11D Value"
          :value="vehicle.p11d_value | currency"
        ></vehicle-detail>
      </div>
    </div>
    <hr />

    <template v-if="!!vehicle.defleet_reason_id">
      <fieldset>
        <legend>Defleeted Details</legend>
        <div class="row">
          <div class="col-md-6">
            <vehicle-detail
              label="Defleet reason"
              :value="vehicle.defleet_reason.label"
            ></vehicle-detail>
            <vehicle-detail
              label="Total Loss Category"
              :value="vehicle.total_loss_category"
            ></vehicle-detail>
          </div>
          <div class="col-md-6">
            <vehicle-detail
              label="Removed from Dart/Congestion"
              :value="vehicle.removed_from_dart_congestion ? 'Yes' : 'No'"
            ></vehicle-detail>
            <vehicle-detail
              label="Removed from MID"
              :value="vehicle.removed_from_mid ? 'Yes' : 'No'"
            ></vehicle-detail>
            <vehicle-detail
              label="V5"
              :value="vehicle.v5 ? 'Yes' : 'No'"
            ></vehicle-detail>
            <vehicle-detail
              label="Spare Key"
              :value="vehicle.spare_key ? 'Yes' : 'No'"
            ></vehicle-detail>
            <vehicle-detail
              label="SORN"
              :value="vehicle.sorn ? 'Yes' : 'No'"
            ></vehicle-detail>
            <vehicle-detail
              v-if="vehicle.defleet_reason.name === 'stolen'"
              label="Unrecovered stolen"
              :value="vehicle.un_recovered_stolen ? 'Yes' : 'No'"
            ></vehicle-detail>
          </div>
        </div>
      </fieldset>
      <div class="row">
        <div class="col-md-6">
          <fieldset>
            <legend>Dates</legend>
            <vehicle-detail
              label="Removed From Dart/Congestion Date"
              :value="vehicle.removed_from_dart_congestion_at | date"
            ></vehicle-detail>
            <vehicle-detail
              label="SORN Date"
              :value="vehicle.sorn_at | date"
            ></vehicle-detail>
            <vehicle-detail
              label="Collection Date"
              :value="vehicle.collection_date | date"
            ></vehicle-detail>
            <vehicle-detail
              label="Off MID date"
              :value="vehicle.off_mid_date | date"
            ></vehicle-detail>
          </fieldset>
        </div>
        <div class="col-md-6" v-if="vehicle.defleet_reason.name !== 'stolen'">
          <fieldset>
            <legend>Disposal Info</legend>

            <vehicle-detail
              v-if="!!vehicle.customer_id"
              label="Customer"
              :value="getCompany(vehicle.customer_id)?.name"
            ></vehicle-detail>

            <div v-if="!vehicle.customer_id && vehicle.customer_name">
              <vehicle-detail
                label="Customer Name"
                :value="vehicle.customer_name"
              ></vehicle-detail>
              <vehicle-detail
                label="Customer Number"
                :value="vehicle.customer_telephone_number"
              ></vehicle-detail>
              <vehicle-detail
                label="Customer Email"
                :value="vehicle.customer_email_address"
              ></vehicle-detail>
              <vehicle-detail
                label="Address line one"
                :value="vehicle.customer_address_line_one"
              ></vehicle-detail>
              <vehicle-detail
                label="Address line two"
                :value="vehicle.customer_address_line_two"
              ></vehicle-detail>
              <vehicle-detail
                label="City"
                :value="vehicle.customer_city"
              ></vehicle-detail>
              <vehicle-detail
                label="Postcode"
                :value="vehicle.customer_postcode"
              ></vehicle-detail>
            </div>
            <!--            <vehicle-detail-->
            <!--              label="Customer"-->
            <!--              :value="vehicle.customer"-->
            <!--            ></vehicle-detail>-->
            <vehicle-detail
              label="Sale Price"
              :value="vehicle.sale_price | currency"
            ></vehicle-detail>
            <vehicle-detail
              label="Sale Date"
              :value="vehicle.sale_date | date"
            ></vehicle-detail>
            <vehicle-detail
              label="Payment Date"
              :value="vehicle.payment_date | date"
            ></vehicle-detail>
            <vehicle-detail
              label="Invoice Number"
              :value="vehicle.invoice_number"
            ></vehicle-detail>
            <vehicle-detail
              label="Collected Date"
              :value="vehicle.collected_at | date"
            ></vehicle-detail>
          </fieldset>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import VehicleDetail from '@/components/Modules/Fleet/Tabs/VehicleDetails/VehicleDetail';

export default {
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },

  components: {
    VehicleDetail
  },

  computed: {
    extras() {
      if (this.vehicle.extras?.length) {
        return this.vehicle.extras.map(extra => extra.label).join(', ');
      }

      return 'None Selected';
    }
  },
  methods: {
    getCompany(id) {
      return this.$store.getters['Companies/all'].find(
        company => company.id === id
      );
    }
  },
  mounted() {
    this.$store.commit('Companies/retrieve');
  }
};
</script>
